module.exports = __webpack_public_path__ + "static/media/RadiusGrey.1f0433c5.svg";